export enum CorePlayerInput {
	LEFT = 'left',
	RIGHT = 'right',
	BACKWARD = 'backward',
	FORWARD = 'forward',
	RUN = 'run',
	JUMP = 'jump',
}
export const CORE_PLAYER_INPUTS: CorePlayerInput[] = [
	CorePlayerInput.LEFT,
	CorePlayerInput.RIGHT,
	CorePlayerInput.BACKWARD,
	CorePlayerInput.FORWARD,
	CorePlayerInput.RUN,
	CorePlayerInput.JUMP,
];
